import React from 'react'

import imgLogo from '../assets/img/logo1.png'
import { useAppDispatch } from '../store'
import { useLoginByPasswordMutation } from '../store/api/api'
import { Credentials, slice as authSlice } from '../store/auth'

// RTK Query .unwrap() реджектит FetchBaseQueryError ({status, data}) или SerializedError,
// а не инстанс Error. Достаём человекочитаемое сообщение из тела ответа.
const extractErrorMessage = (error: unknown): string => {
  if (error && typeof error === 'object' && 'data' in error) {
    const data = (error as { data: unknown }).data
    if (typeof data === 'string' && data.length > 0) return data
    if (data && typeof data === 'object' && 'message' in data) {
      const message = (data as { message: unknown }).message
      if (typeof message === 'string' && message.length > 0) return message
    }
  }
  if (error instanceof Error && error.message) return error.message
  return 'Ошибка входа'
}

const Login = () => {
  const dispatch = useAppDispatch()

  const [loginByPassword, { isLoading }] = useLoginByPasswordMutation()

  const [{ login, password }, updateForm] = React.useReducer(
    (state: Credentials, changes: Partial<Credentials>) => ({
      ...state,
      ...changes,
    }),
    {
      login: '',
      password: '',
    },
  )

  const [errorMessage, setErrorMessage] = React.useState<string | null>(null)

  const isReady = login.length > 0 && password.length > 0 && !isLoading

  const handleLoginChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateForm({ login: event.target.value })
  }

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateForm({ password: event.target.value })
  }

  const handleSubmit = React.useCallback(async () => {
    setErrorMessage(null)
    try {
      const result = await loginByPassword({ username: login, password }).unwrap()
      dispatch(authSlice.actions.loginSuccess(result.accessToken))
    } catch (error: unknown) {
      setErrorMessage(extractErrorMessage(error))
    }
  }, [login, password, loginByPassword, dispatch])

  return (
    <div className="page__container">
      <div className="page__content">
        <div className="main__container">
          <div className="main__content">
            <div className="main__logo">
              <img src={imgLogo} alt="logo" />
            </div>
            <div className="main__logo-text">АРМ раннера</div>
            <div className="input">
              <label className="input__label">
                <span className="input_error-text"></span>
              </label>
              <input
                className="input__input"
                type="text"
                value={login}
                name="login"
                placeholder="Логин"
                onChange={handleLoginChange}
              />
            </div>
            <div className="input">
              <label className="input__label">
                <span className="input_error-text"></span>
              </label>
              <input
                className="input__input"
                type="password"
                value={password}
                name="password"
                placeholder="Пароль"
                onChange={handlePasswordChange}
              />
            </div>
            <button className="main__button" type="button" disabled={!isReady} onClick={handleSubmit}>
              {isLoading ? 'Вход...' : 'Войти'}
            </button>
            {errorMessage ? <p>{errorMessage}</p> : null}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
